import { render, staticRenderFns } from "./Onway.vue?vue&type=template&id=03fc24df&scoped=true&"
import script from "./Onway.vue?vue&type=script&lang=js&"
export * from "./Onway.vue?vue&type=script&lang=js&"
import style0 from "./Onway.vue?vue&type=style&index=0&id=03fc24df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fc24df",
  null
  
)

export default component.exports